<!--
  ~ Copyright (c) by INFODATA-GROUP. All rights reserved.
  ~ No part of this publication may be reproduced, distributed,
  ~ or transmitted in any form or by any means, including photocopying, recording,
  ~ or other electronic or mechanical methods, without the prior written permission of the publisher,
  ~ except in the case of brief quotations embodied in critical
  ~ reviews and certain other noncommercial uses permitted by copyright law.
  ~  author : vhe
  ~  date : 02/03/2021 07:39
  -->

@if (this.sections()) {
  <div class="column" (dragleave)="clearLastSectionHighlighted()">
    @for (section of sections(); track section.day; let i = $index) {
      <div
        class="section"
        [class.current]="section.isCurrentDay"
        [class.selected]="section === selectedSection()"
        [class.grayed]="section.grayed"
        [style.height.px]="section.height"
        [style.background-color]="cellsBackgroundColor()[i]"
        (dragover)="onDragOver($event, i)"
        (drop)="onDropTask(section)"
        (click)="selectSection(section, $event)"
        (dblclick)="selectByDblClick(section, $event)"
        (mouseover)="onOverZone(section, $event)"
        (dragenter)="$event.preventDefault()"
        (dragleave)="$event.preventDefault()"
      >
        @for (task of viewTasks[i]; track task.task.id) {
          <div
            class="task"
            [class.enable]="enable()"
            [style]="task.style"
            [draggable]="canDrag() && task.task.enable"
            (dragstart)="onDragStart(task)"
            (mouseenter)="taskHover.emit(task.task)"
            (mouseleave)="taskHover.emit(null)"
            (click)="onTaskClick($event, task.task)"
            (dblclick)="onTaskClick($event, task.task, true)"
          >
            <div
              class="background"
              [style.background-color]="task.task.backgroundColor.length === 9
                    ? task.task.backgroundColor
                    : task.task.backgroundColor + 'BF'"
            >
              <div class="text">
                @if (task.task.icon) {
                  <span class="icon fal fa-{{ task.task.icon }}"></span>
                }
                {{ task.task.label | removeBr }}
              </div>
            </div>
          </div>
        }
      </div>
    }
  </div>
}
